import { motion } from 'framer-motion';
import { cn } from '@/utils';
import { BuildAiButtons } from './BuildAiButtons';
import { BuildQuizFloatingButtons } from './BuildQuizFloatingButtons';
import { QuizList } from './QuizList';
import { QuizSliderSidebar } from './QuizSlider';
import { BuildQuizButtons } from '.';
type BuildStepQuizProps = {
  /**
   * 현재 step이 'quiz'인지 여부.
   * false일 때는 display:none으로 화면에서만 숨기고 mount는 유지한다.
   * 이로써 카드 N개의 옵저버/구독/RHF 바인딩이 step 토글에도 살아남는다.
   */
  active: boolean;
};
export const BuildStepQuiz = ({
  active
}: BuildStepQuizProps) => {
  return (
    // display:none → IntersectionObserver / ResizeObserver / layout이 자동 비활성화.
    // 접근성/탭 포커스도 display:none이 자동으로 제거하므로 inert는 불필요.
    <div aria-hidden={!active} style={{
      display: active ? 'block' : 'none'
    }} data-sentry-component="BuildStepQuiz" data-sentry-source-file="BuildStepQuiz.tsx">
      <QuizSliderSidebar data-sentry-element="QuizSliderSidebar" data-sentry-source-file="BuildStepQuiz.tsx" />
      <motion.div key={'quiz'}
      // 항상 mount 상태이므로 AnimatePresence enter/exit 대신 active 변화에 따라
      // 직접 opacity + x를 애니메이트한다.
      // 기존 동작 재현: active=true 진입 시 x:-20 → 0으로 슬라이드 인.
      // initial={false}로 첫 mount에서 깜빡임을 막는다.
      initial={false} animate={{
        opacity: active ? 1 : 0,
        x: active ? 0 : -20
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} style={{
        position: 'relative'
      }} data-sentry-element="unknown" data-sentry-source-file="BuildStepQuiz.tsx">
        <div className={cn('max-w-[650px] mx-auto flex w-full flex-col gap-lg tablet-sm:gap-[48px]', 'px-md mobile-lg:px-lg tablet-lg:px-0')}>
          <div className={'flex flex-col'}>
            <BuildAiButtons data-sentry-element="BuildAiButtons" data-sentry-source-file="BuildStepQuiz.tsx" />
            <QuizList data-sentry-element="QuizList" data-sentry-source-file="BuildStepQuiz.tsx" />
            <BuildQuizButtons data-sentry-element="BuildQuizButtons" data-sentry-source-file="BuildStepQuiz.tsx" />
            <BuildQuizFloatingButtons data-sentry-element="BuildQuizFloatingButtons" data-sentry-source-file="BuildStepQuiz.tsx" />
          </div>
        </div>
      </motion.div>
    </div>
  );
};